import { Routes } from '@angular/router';
import { redirectToShowcodeGuard } from './guards/redirect-to-showcode.guard';

export const routes: Routes = [
  {
    path: 'code',
    loadComponent: () =>
      import('./pages/showcode/showcode.component').then(
        (m) => m.ShowcodeComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/redeem/redeem.component').then((m) => m.RedeemComponent),
    canActivate: [redirectToShowcodeGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/redeem/redeem.component').then((m) => m.RedeemComponent),
    canActivate: [redirectToShowcodeGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
